<template>
  <v-card v-if="!!value && !!value.viewConfigs" flat>
    <v-switch
      v-model="computedValue.viewConfigs.autoCsvDownload"
      dense
      :hint="$t('auto_csv_download_hint')"
      inset
      :label="$t('auto_csv_download_label')"
      persistent-hint
    />

    <v-switch
      v-model="computedValue.viewConfigs.showCClubOnload"
      dense
      :hint="$t('show_cclub_onload_hint')"
      inset
      :label="$t('show_cclub_onload_label')"
      persistent-hint
    />

    <v-radio-group
      v-if="computedValue.viewConfigs.showCClubOnload"
      v-model="computedValue.viewConfigs.forcedSubmission"
      dense
      :hint="$t('forced_submission_hint')"
      mandatory
      persistent-hint
      row
    >
      <v-radio :label="$t('forced_submission_forced')" value="forced" />
      <v-radio :label="$t('forced_submission_optional')" value="optional" />
    </v-radio-group>

    <v-switch
      v-model="computedValue.hasManifestIcons"
      :persistent-hint="computedValue.hasManifestIcons"
      dense
      :hint="$t('has_manifest_icons_hint')"
      inset
      :label="$t('has_manifest_icons_label')"
    />

    <create-installability-icons
      v-if="computedValue.hasManifestIcons"
      v-model="computedValue.manifest"
    />
    <v-switch
      v-model="computedValue.hasAssistants"
      :persistent-hint="computedValue.hasAssistant"
      dense
      :hint="$t('has_assistant_hint')"
      inset
      :label="$t('has_assistant_label')"
    />
    <!-- <assistant-ai-list
      v-if="computedValue.hasAssistants"
      v-model="computedValue.assistantId"
      @change="onAssistantChange"
    /> -->
    <ai-chat-settings
      v-if="computedValue.hasAssistants"
      v-model="computedValue.aiChatConfig"
    />
  </v-card>
</template>

<script>
import CreateInstallabilityIcons from "@/view/components/fragments/createInstallabilityIcons.vue";
import AssistantAiList from "./assistantAiList.vue";
import aiChatSettings from "./aiChatSettings.vue";

export default {
  name: "advanceSettings",

  components: { CreateInstallabilityIcons, AssistantAiList, aiChatSettings },

  props: {
    value: Object,
  },
  data() {
    return {
      serviceName: "Qrland",
      componentName: "advanceSettings",
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        if (!this.value?.viewConfigs) {
          this.computedValue = {
            viewConfigs: {
              autoCsvDownload: false,
              showCClubOnload: false,
              forcedSubmission: "optional",
            },
            hasManifestIcons: false,
            hasAssistants: false,
            aiChatConfig: {
              assistantId: null,
              assistant: null,
              hasAssistants: false,
              hasAssistantsName: false,
              hasAssistantsFamily: false,
              hasAssistantsMobile: false,
              chatSettings: {
                headerColor: "#667eea",
                headerColor2: "#764ba2",
                headerGradient: true,
                backgroundColor: "#ffffff",
                backgroundImage: null,
                useImageBackground: false,
                textColor: "#333333",
                fontSize: 14,
                chatLogo: null,
                floatingIcon: "mdi-robot",
                useImageLogo: false,
              },
            },
            manifest: {
              icon48: "",
              icon144: "",
              screenshotWide: "",
              screenshot600: "",
            },
            ...(this.value ?? {}),
          };
        }
      },
      immediate: true,
    },
  },

  mounted() {
    if (!this.value?.viewConfigs) {
      this.computedValue = {
        viewConfigs: {
          autoCsvDownload: false,
          showCClubOnload: false,
          forcedSubmission: "optional",
        },
        hasManifestIcons: false,
        hasAssistants: false,
        aiChatConfig: {
          assistantId: null,
          assistant: null,
          hasAssistants: false,
          hasAssistantsName: false,
          hasAssistantsFamily: false,
          hasAssistantsMobile: false,
          chatSettings: {
            headerColor: "#667eea",
            headerColor2: "#764ba2",
            headerGradient: true,
            backgroundColor: "#ffffff",
            backgroundImage: null,
            useImageBackground: false,
            textColor: "#333333",
            fontSize: 14,
            chatLogo: null,
            floatingIcon: "mdi-robot",
            useImageLogo: false,
          },
        },
        manifest: {
          icon48: "",
          icon144: "",
          screenshotWide: "",
          screenshot600: "",
        },
      };
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    onAssistantChange(assistant) {
      if (assistant) {
        const newValue = {
          ...this.value,
          assistant: assistant,
          assistantId: assistant.id,
          chatSettings: this.value?.chatSettings || {
            headerColor: "#667eea",
            backgroundColor: "#ffffff",
            textColor: "#333333",
            fontSize: 14,
            backgroundImage: null,
            chatLogo: null,
            floatingIcon: "mdi-robot",
            assistantName: "",
          },
        };
        this.$emit("input", newValue);
        this.$nextTick(() => {
          this.activeTab = 1;
        });
      } else {
        this.$emit("input", {
          ...this.value,
          assistant: null,
          assistantId: null,
        });
      }
    },
  },
};
</script>

<style scoped></style>
